import { Link } from "react-router-dom";
import CustomButton from "../../../common/CustomButton";

function WelcomePage({ moveNext, backLogin }) {
    return (
        <div id="uo-welcome-page" className="uo-component div-45-55">
            <div id="uo-wp-banner">
                <img src="/assets/images/onboarding/onboarding-welcome-banner.png" className="onboarding-banner" />
            </div>
            <div id="uo-wp-text" className="bottom-text-area">
                <h4>Your Fresh Start to Fitness</h4>
                <h6>Enjoy 200+ workouts crafted by Physical Therapists to make wellness work for you.</h6>
                <CustomButton className="uo-button active" onClick={moveNext}>Continue</CustomButton>

                <h5 id="login-text" onClick={() => {
                    backLogin();
                }}>
                    Already a member? <span>Login</span>
                </h5>
            </div>
        </div>
    );
}

export default WelcomePage;